/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const AlertCircleFilledIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Alert Circle Filled',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18 2a16 16 0 1 0 16 16A16 16 0 0 0 18 2Zm-2.6 4.775a.711.711 0 0 1 .337-.675 6.246 6.246 0 0 1 2.225-.458 6.861 6.861 0 0 1 2.232.344.777.777 0 0 1 .4.687v2.45c0 2.885-.577 10.891-.683 11.947a.527.527 0 0 1-.587.52H16.6a.568.568 0 0 1-.578-.473c-.1-1.364-.622-9.1-.622-11.891ZM18 28.85a2.574 2.574 0 0 1-2.8-2.631 2.66 2.66 0 0 1 2.8-2.7 2.632 2.632 0 0 1 2.8 2.7A2.574 2.574 0 0 1 18 28.85Z"
    />
  </svg>`;
};
